import {
  ReactNode,
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { tokenTemporaryService } from "../../services/tokenTemorary.service";
import { ILoginTemporary, ITemporaryUser } from "../../models/authorizations";

interface ITemporaryAccessProps {
  children: ReactNode;
}

const TemporaryAccessContext = createContext<ITemporaryUser>({
  userTemporary: {
    token: "",
    name: "",
    id: "",
  },
  hasUser: false,
  fetchTemporaryUser: () => {},
});

export const TemporaryAccessProvider: React.FC<ITemporaryAccessProps> = ({
  children,
}) => {
  const isTemporaryAccess = tokenTemporaryService.hasTemporaryAccessToken();

  const [userTemporary, setUserTemporary] = useState<ILoginTemporary>({
    id: "",
    name: "",
    token: "",
  });

  const [hasUser] = useState<boolean>(false);

  const fetchTemporaryUser = useCallback((tempUser: ILoginTemporary) => {
    setUserTemporary(tempUser);
  }, []);

  useEffect(() => {
    if (isTemporaryAccess) {
    }
  }, [isTemporaryAccess]);

  const value = useMemo(
    () => ({
      userTemporary,
      hasUser,
      fetchTemporaryUser,
    }),
    [userTemporary, hasUser, fetchTemporaryUser]
  );

  return (
    <TemporaryAccessContext.Provider value={value}>
      {children}
    </TemporaryAccessContext.Provider>
  );
};

export const useTemporaryAccess = () => {
  const context = useContext(TemporaryAccessContext);
  return context;
};
